import * as FlagIcons from "country-flag-icons/react/3x2";

const FLAG_SIZE = {
  small: { width: 16, height: 12 },
  medium: { width: 20, height: 15 },
};

const normalizeCountryCode = (countryCode) => {
  if (!countryCode) return null;
  return String(countryCode).toUpperCase().replace(/-/g, "_");
};

export const getCountryCodeFromAreaCodeItem = (item) => {
  return normalizeCountryCode(item?.country_code);
};

export const getAreaCodeDisplayInfo = (item) => ({
  name: item?.country_name?.trim() || "",
  countryCode: getCountryCodeFromAreaCodeItem(item),
  areaCodeLabel: item?.area_code ? `+${item.area_code}` : "",
});

export const CountryFlag = ({ countryCode, size = "medium", style, ...props }) => {
  const normalizedCountryCode = normalizeCountryCode(countryCode);
  if (!normalizedCountryCode) return null;

  const Flag = FlagIcons[normalizedCountryCode];
  if (!Flag) return null;

  return (
    <Flag
      title={normalizedCountryCode}
      style={{
        borderRadius: 2,
        flexShrink: 0,
        objectFit: "cover",
        ...FLAG_SIZE[size],
        ...style,
      }}
      {...props}
    />
  );
};

export const AreaCodeLabel = ({ item }) => {
  const { name, countryCode, areaCodeLabel } = getAreaCodeDisplayInfo(item);
  const text = [areaCodeLabel, name].filter(Boolean).join(" ");

  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
      <CountryFlag countryCode={countryCode} />
      <span>{text}</span>
    </span>
  );
};

export const buildAreaCodeOption = (item) => ({
  label: <AreaCodeLabel item={item} />,
  value: item.area_code,
});
